import { ButtonNewRecord, FormCol2, FormCol3 } from 'motion-components';
import React, { FC, ComponentProps } from 'react';
import { Button } from 'react-bootstrap';
import { FaPlus } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

type Props = ComponentProps<typeof Button> & { label; onClick };

export const ColButtonNew: FC<Props> = (props) => {
  const { i18n, t } = useTranslation();
  return (
    <FormCol3
      style={{
        maxHeight: '2rem',
        alignSelf: 'center',
        marginTop: '5px',
      }}
    >
      <ButtonNewRecord
        label={t(props.label)}
        onClick={props.onClick}
        size="sm"
        // disabled={props.disabled}
        {...props}
      />
    </FormCol3>
  );
};

